import { render, staticRenderFns } from "./ThumbsDown.vue?vue&type=template&id=1492debc&scoped=true&"
import script from "./ThumbsDown.vue?vue&type=script&lang=js&"
export * from "./ThumbsDown.vue?vue&type=script&lang=js&"
import style0 from "./ThumbsDown.vue?vue&type=style&index=0&id=1492debc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492debc",
  null
  
)

export default component.exports